import { Component, OnDestroy, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { ModelService } from '../services/model.service';
import { AlertData } from './alert-data.entity';

@Component({
	selector: 'app-alert',
	templateUrl: './alert.component.html',
	styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnDestroy {

	@Input() public title: string;
	@Input() public message: string;
	@Input() public messages: string[];
	@Input() public type: string;

	public isShown: boolean = false;
	private showSubs: Subscription;

	constructor(public modelService: ModelService) {
		this.showSubs = modelService.alertSignal.subscribe((data: AlertData) => { this.show(data); });
	}

	public show(data?: AlertData): void {
		// En caso de que se reciba un data:
		// Se sobreescriben los datos que hayan llegado por Input() al componente
		this.title = '';
        this.message = '';
        this.messages = [];

		if (data) {
            this.title = (data.title !== undefined) ? data.title: '';
            this.message = (data.message !== undefined) ? data.message: '';
            this.messages = (data.messages !== undefined) ? data.messages: [];
			this.type = data.type;
		}
		this.isShown = true;
	}

	public close(): void {
		this.isShown = false;
	}

	public ngOnDestroy() {
		this.showSubs.unsubscribe();
	}

}


